import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export default function EndpointBasicInfoComponent ({handleInnerFormChange, selectedEndpoint}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedEndpoint?.Name}
          />
        
        <div className='col-span-full'>
   <InputContainer

label="Description"

onValueChange={(event: any) => {
    handleInnerFormChange(
        event.target.value,
       'Description'
       );
}}
type="text"
value={selectedEndpoint?.Description}
/></div>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}